type ScrollFlag = { current: boolean };

export function observeConversationScroll(
  area: HTMLElement,
  content: HTMLElement,
  initialScrollPending: ScrollFlag,
  loadingOlder: ScrollFlag,
  stickToBottom: ScrollFlag,
  sending: boolean,
) {
  let frame = 0;
  const shouldScroll = () =>
    !loadingOlder.current &&
    stickToBottom.current &&
    (initialScrollPending.current || sending);
  const observer = new ResizeObserver(() => {
    if (!shouldScroll()) return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      // User input or pagination may have changed the scroll policy since
      // the resize was observed. Never apply a stale decision on this frame.
      if (!shouldScroll()) return;
      area.scrollTop = area.scrollHeight;
      initialScrollPending.current = false;
    });
  });
  observer.observe(content);
  return () => {
    cancelAnimationFrame(frame);
    observer.disconnect();
  };
}
